(function () {
  var DOUBLE_CLICK_MS = 320;
  var PAN_THRESHOLD = 6;

  function getZoomItems(slider) {
    var items = [];
    slider.querySelectorAll('.slick-slide:not(.slick-cloned) .js-pdp-media-zoom').forEach(function (img) {
      items.push({
        src: img.getAttribute('data-zoom-src') || img.currentSrc || img.src,
        alt: img.getAttribute('alt') || '',
      });
    });
    return items;
  }

  function findZoomIndex(items, src) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].src === src) return i;
    }
    return 0;
  }

  function initPdpMediaLightbox() {
    var slider = document.querySelector('.slick-media-slider');
    var lightbox = document.getElementById('pdp-media-lightbox');
    var lbImg = document.getElementById('pdp-media-lightbox-img');
    var lbStage = lightbox ? lightbox.querySelector('.pdp-media-lightbox__stage') : null;

    if (!slider || !lightbox || !lbImg || slider.dataset.pdpZoomBound === 'true') return;
    slider.dataset.pdpZoomBound = 'true';

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var zoomItems = [];
    var zoomIndex = 0;
    var lbScale = 1;
    var lbPanX = 0;
    var lbPanY = 0;
    var lbPanning = false;
    var lbPanMoved = false;
    var lbSuppressClick = false;
    var lbPanStartX = 0;
    var lbPanStartY = 0;
    var lbPanOriginX = 0;
    var lbPanOriginY = 0;
    var lbLastClickTime = 0;
    var lbClickTimer = null;

    function resetLbImageZoom() {
      lbScale = 1;
      lbPanX = 0;
      lbPanY = 0;
      lbImg.style.transform = '';
      lbImg.style.cursor = 'zoom-in';
      lbImg.classList.remove('is-zoomed');
      if (lbStage) lbStage.classList.remove('is-panning');
    }

    function applyLbTransform() {
      lbImg.style.transform = 'translate(' + lbPanX + 'px, ' + lbPanY + 'px) scale(' + lbScale + ')';
    }

    function zoomLbIn(clientX, clientY) {
      if (lbScale > 1) return;

      var rect = lbImg.getBoundingClientRect();
      var relX = rect.width ? (clientX - rect.left) / rect.width - 0.5 : 0;
      var relY = rect.height ? (clientY - rect.top) / rect.height - 0.5 : 0;

      lbScale = 2;
      lbPanX = -relX * rect.width * (lbScale - 1);
      lbPanY = -relY * rect.height * (lbScale - 1);
      lbImg.classList.add('is-zoomed');
      lbImg.style.cursor = 'zoom-out';
      applyLbTransform();
    }

    function zoomLbOut() {
      resetLbImageZoom();
    }

    function clearLbClickTimer() {
      if (lbClickTimer) {
        clearTimeout(lbClickTimer);
        lbClickTimer = null;
      }
    }

    function openZoom(img) {
      var src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
      zoomItems = getZoomItems(slider);
      zoomIndex = findZoomIndex(zoomItems, src);
      clearLbClickTimer();
      lbLastClickTime = 0;
      resetLbImageZoom();
      lbImg.src = zoomItems[zoomIndex].src;
      lbImg.alt = zoomItems[zoomIndex].alt;
      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-media-lightbox-open');
    }

    function closeZoom() {
      clearLbClickTimer();
      lbLastClickTime = 0;
      resetLbImageZoom();
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      lbImg.removeAttribute('src');
      document.body.classList.remove('pdp-media-lightbox-open');
    }

    function showZoom(delta) {
      if (!zoomItems.length) return;
      clearLbClickTimer();
      lbLastClickTime = 0;
      resetLbImageZoom();
      zoomIndex = (zoomIndex + delta + zoomItems.length) % zoomItems.length;
      lbImg.src = zoomItems[zoomIndex].src;
      lbImg.alt = zoomItems[zoomIndex].alt;
    }

    function shouldIgnoreSliderZoom() {
      var list = slider.querySelector('.slick-list');
      return !!(list && list.classList.contains('dragging'));
    }

    function onSliderImageActivate(e) {
      var img = e.target.closest('.js-pdp-media-zoom');
      if (!img || !slider.contains(img) || shouldIgnoreSliderZoom()) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      openZoom(img);
    }

    slider.addEventListener('click', onSliderImageActivate, true);
    slider.addEventListener('touchend', onSliderImageActivate, true);

    slider.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var img = e.target.closest('.js-pdp-media-zoom');
      if (!img) return;
      e.preventDefault();
      openZoom(img);
    });

    function onLbImageClick(e) {
      if (lbSuppressClick) {
        lbSuppressClick = false;
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (lbPanMoved) {
        lbPanMoved = false;
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (lbScale > 1) {
        clearLbClickTimer();
        lbLastClickTime = 0;
        zoomLbOut();
        return;
      }

      var now = Date.now();

      if (lbLastClickTime && now - lbLastClickTime <= DOUBLE_CLICK_MS) {
        clearLbClickTimer();
        lbLastClickTime = 0;
        zoomLbIn(e.clientX, e.clientY);
        return;
      }

      lbLastClickTime = now;
      clearLbClickTimer();
      lbClickTimer = setTimeout(function () {
        lbLastClickTime = 0;
        lbClickTimer = null;
      }, DOUBLE_CLICK_MS);
    }

    lbImg.addEventListener('click', onLbImageClick);

    lbImg.addEventListener('mousedown', function (e) {
      if (lbScale <= 1 || e.button !== 0) return;

      lbPanning = true;
      lbPanMoved = false;
      lbPanStartX = e.clientX;
      lbPanStartY = e.clientY;
      lbPanOriginX = lbPanX;
      lbPanOriginY = lbPanY;
      lbImg.style.cursor = 'grabbing';
      if (lbStage) lbStage.classList.add('is-panning');
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!lbPanning) return;

      var dx = e.clientX - lbPanStartX;
      var dy = e.clientY - lbPanStartY;

      if (Math.abs(dx) > PAN_THRESHOLD || Math.abs(dy) > PAN_THRESHOLD) {
        lbPanMoved = true;
      }

      lbPanX = lbPanOriginX + dx;
      lbPanY = lbPanOriginY + dy;
      applyLbTransform();
    });

    document.addEventListener('mouseup', function () {
      if (!lbPanning) return;

      lbPanning = false;
      lbImg.style.cursor = lbScale > 1 ? 'zoom-out' : 'zoom-in';
      if (lbStage) lbStage.classList.remove('is-panning');

      if (lbPanMoved) {
        lbSuppressClick = true;
      }
    });

    var closeBtn = lightbox.querySelector('.pdp-media-lightbox__close');
    var prevBtn = lightbox.querySelector('.pdp-media-lightbox__nav--prev');
    var nextBtn = lightbox.querySelector('.pdp-media-lightbox__nav--next');

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeZoom();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showZoom(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        showZoom(1);
      });
    }

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeZoom();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-active')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') showZoom(-1);
      if (e.key === 'ArrowRight') showZoom(1);
    });
  }

  function initSlickSlider() {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    var $slider = jQuery('.slick-media-slider');
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;

    var isDesktop = window.matchMedia('(min-width: 750px)').matches;

    $slider.on('beforeChange', function () {
      $slider.find('video').each(function () {
        this.pause();
      });
    });

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '8%',
      arrows: true,
      dots: false,
      infinite: true,
      adaptiveHeight: false,
      draggable: !isDesktop,
      swipe: !isDesktop,
      appendArrows: '.slick-arrows-wrap',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '6%',
            draggable: true,
            swipe: true,
          },
        },
      ],
    });
  }

  function boot() {
    initSlickSlider();
    window.setTimeout(initPdpMediaLightbox, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
